jQuery(document).ready(function ($) {

    $('.bloc_chapeau').each(function () {
        const $block = $(this)
        const $brush = $block.find('img.brush')
        const textEls = $block.find('.inner').children().not('img').get()

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: $block[0],
                start: 'top 85%',
                once: true
            }
        })

        // Animation du texte ligne par ligne
        if (textEls.length) {
            const split = new SplitText(textEls, { type: 'lines' })

            tl.from(split.lines, {
                opacity: 0,
                y: 30,
                duration: 0.7,
                ease: 'power3.out',
                stagger: 0.1
            })
        }

        // Animation du pinceau après les lignes
        if ($brush.length) {
            tl.fromTo($brush[0],
                { clipPath: 'inset(0 100% 0 0)' },
                {
                    clipPath: 'inset(0 0% 0 0)',
                    duration: 0.5,
                    ease: "power3.out",
                }
            )
        }
    })
})
